export enum TrackSessionStatus {
  Recording = 'recording',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}
